import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary-200/50 blur-3xl" />
      <div className="pointer-events-none absolute -right-16 bottom-0 h-72 w-72 rounded-full bg-accent-200/40 blur-3xl" />

      <div className="relative mx-auto grid max-w-none grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-2 lg:gap-12">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-tools-line" />
            工具型下载指引 · 安卓 / iOS 全覆盖
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl lg:text-5xl">
            91免费版app下载安装
            <span className="mt-1 block text-primary-600">全攻略：从获取到上手</span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
            覆盖安卓与 iOS 双平台的 91免费版app下载指引，包含安装包获取、安装步骤与使用说明。
            无论你是找不到安装包，还是卡在安装失败，这里都能按步骤快速解决。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#download"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-android-line text-lg" />
              安卓安装包下载
            </a>
            <a
              href="#download"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-900 transition-colors hover:bg-background-100"
            >
              <i className="ri-apple-line text-lg" />
              iOS 安装指引
            </a>
          </div>

          <dl className="mt-9 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-300/70 pt-7 sm:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <dt className="text-xs text-foreground-500">{stat.label}</dt>
                <dd className="mt-1 font-heading text-lg font-bold text-foreground-950">{stat.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative">
          <div className="relative mx-auto w-full max-w-[420px]">
            <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20smartphone%20floating%20at%20a%20slight%20angle%20displaying%20a%20clean%20modern%20download%20app%20interface%20with%20progress%20bars%20and%20download%20cards%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20studio%20lighting%2C%20minimal%20abstract%20geometric%20background%20shapes%2C%20subtle%20paper%20texture%2C%20editorial%20tech%20product%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=980&seq=hero-phone-91&orientation=portrait"
                alt="91免费版app下载界面示意"
                title="91免费版下载安装指引"
                className="h-[380px] w-full object-top md:h-[460px]"
              />
            </div>

            <div className="animate-floaty absolute -left-3 top-8 hidden rounded-lg border border-background-200 bg-background-50 px-3 py-2 sm:block">
              <p className="text-[11px] text-foreground-500">安装成功率</p>
              <p className="font-heading text-sm font-bold text-accent-600">99.2%</p>
            </div>
            <div className="absolute -bottom-4 right-0 w-[230px] rounded-lg border border-background-200 bg-background-50 p-3">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className="ri-android-line" />
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-xs font-medium text-foreground-900">91免费版 v9.1.12</p>
                  <p className="text-[11px] text-foreground-500">28.6 MB · 正在下载</p>
                </div>
              </div>
              <div className="mt-2.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                <div className="h-full w-3/4 rounded-full bg-primary-500" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}